/**
 * PolicySlice Edit Tracking Reducers
 * 
 * Reducers for managing edit state and dirty tracking.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { PolicySliceState } from '../state';

// =============================================================================
// EDIT TRACKING REDUCERS
// =============================================================================

/**
 * Mark a specific field as edited
 */
export const markFieldAsEdited: CaseReducer<PolicySliceState, PayloadAction<string>> = (
  state,
  action
) => {
  if (!state.editedFields.includes(action.payload)) {
    state.editedFields.push(action.payload);
  }
  state.isEdited = true;
};

/**
 * Clear all edited fields tracking
 */
export const clearEditedFields: CaseReducer<PolicySliceState> = (state) => {
  state.editedFields = [];
  state.isEdited = false;
};

/**
 * Mark as saved - clears edit tracking
 */
export const markAsSaved: CaseReducer<PolicySliceState> = (state) => {
  state.isEdited = false;
  state.editedFields = [];
};

/**
 * Discard changes - clears edit tracking (UI should refetch from API)
 */
export const discardChanges: CaseReducer<PolicySliceState> = (state) => {
  state.isEdited = false;
  state.editedFields = [];
};

// =============================================================================
// VALIDATION REDUCERS
// =============================================================================

/**
 * Set a validation error for a specific field
 */
export const setValidationError: CaseReducer<
  PolicySliceState,
  PayloadAction<{ field: string; message: string }>
> = (state, action) => {
  state.validationErrors[action.payload.field] = action.payload.message;
};

/**
 * Clear a validation error for a specific field
 */
export const clearValidationError: CaseReducer<PolicySliceState, PayloadAction<string>> = (
  state,
  action
) => {
  delete state.validationErrors[action.payload];
};

/**
 * Clear all validation errors
 */
export const clearAllValidationErrors: CaseReducer<PolicySliceState> = (state) => {
  state.validationErrors = {};
};
